// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1YKIO","label":"Labeled_label__3httH","divider":"Labeled_divider__8IF3N"};